import { getContractDetailsEndpoint } from './contracts';

export function getPaymentOverviewDetailsEndpoint(contractId: string): string {
    return `${getContractDetailsEndpoint(contractId)}/payment-overview`;
}
